export enum TaskType {
    Individual = 1,   //Individual task rename to Single task
    Group = 2,        //Group task rename to Multiple task  
    Subtask = 4,
    GroupChildTask = 3
}

export enum SavedSearchTask {
    TaskId = 0,
    TaskTitle = 3
}
